@if (userData) {
  <div class="container single-view" id="you-account">
    <div class="row">
      <div class="col-12">
        <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
          <div class="title-wr">
            <h1 data-testid="my-account-header-title" class="section-title">{{ 'YOUR_ACCOUNT.TITLE' | translate }}</h1>
            <p data-testid="my-account-header-subtitle" class="section-subtitle mt-1 text-base">{{ 'YOUR_ACCOUNT.SUBTITLE' | translate }}</p>
          </div>
          <div class="flex items-end justify-between gap-3"></div>
        </div>
        <hr role="presentation" class="w-full mb-6 mt-4 border-t">
        <div class="view-content-wr">
          <form [formGroup]="yourAccountForm" id="account-settings">
            <section class="row">
              <div class="flex flex-col col-12 mb-4">
                <h2 data-testid="my-account-personal-info">{{ 'YOUR_ACCOUNT.PERSONAL_INFORMATION' | translate }}</h2>
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" [ngClass]="{'disabled': !allowUserUpdate}">
                <label data-testid="my-account-field-firstname" class="block text-sm" for="firstname">{{ 'YOUR_ACCOUNT.FIRST_NAME' | translate }} <i class="icon-required-field"></i></label>
                <input data-testid="my-account-firstname-input" type="text" formControlName="firstname" tabindex="10" autocomplete="off">
                @if (
                  yourAccountForm.get('firstname')?.invalid &&
                  (yourAccountForm.get('firstname')?.dirty || yourAccountForm.get('firstname')?.touched)
                ) {
                  @if (yourAccountForm.get('firstname')?.hasError('required')) {
                    <small data-testid="firstname-validation-error" class="p-error">
                      {{ 'YOUR_ACCOUNT.VALIDATE_FIRSTNAME' | translate }}
                    </small>
                  }
                }
              </div>

              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" [ngClass]="{'disabled': !allowUserUpdate}">
                <label data-testid="my-account-field-lastname" class="block text-sm" for="lastname">{{ 'YOUR_ACCOUNT.LAST_NAME' | translate }} <i class="icon-required-field"></i></label>
                <input data-testid="my-account-lastname-input" type="text" formControlName="lastname" tabindex="11" autocomplete="off">
                @if (
                  yourAccountForm.get('lastname')?.invalid &&
                  (yourAccountForm.get('lastname')?.dirty || yourAccountForm.get('lastname')?.touched)
                ) {
                  @if (yourAccountForm.get('lastname')?.hasError('required')) {
                    <small data-testid="lastname-validation-error" class="p-error">
                      {{ 'YOUR_ACCOUNT.VALIDATE_LASTNAME' | translate }}
                    </small>
                  }
                }
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" [ngClass]="{'disabled': !allowUserUpdate}">
                <label data-testid="my-account-field-romanisedfirstname" class="block text-sm" for="r-firstname">{{ 'YOUR_ACCOUNT.ROMANIZED_FIRST_NAME' | translate }}</label>
                <input data-testid="my-account-romanisedfirstname-input" type="text" formControlName="romanisedFirstName" tabindex="12" autocomplete="off">
                @if (
                  yourAccountForm.get('romanisedFirstName')?.invalid &&
                  (yourAccountForm.get('romanisedFirstName')?.dirty || yourAccountForm.get('romanisedFirstName')?.touched)
                ) {
                  @if (yourAccountForm.get('romanisedFirstName')?.errors?.['invalidCharacters']) {
                    <small data-testid="romanisedfirstname-format-error" class="p-error">
                      {{ 'USER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                    </small>
                  }
                }
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" [ngClass]="{'disabled': !allowUserUpdate}">
                <label data-testid="my-account-field-romanisedlastname" class="block text-sm" for="r-lastname">{{ 'YOUR_ACCOUNT.ROMANIZED_LAST_NAME' | translate }}</label>
                <input data-testid="my-account-romanisedlastname-input" type="text" formControlName="romanisedLastName" tabindex="13" autocomplete="off" >
                @if (
                  yourAccountForm.get('romanisedLastName')?.invalid &&
                  (yourAccountForm.get('romanisedLastName')?.dirty || yourAccountForm.get('romanisedLastName')?.touched)
                ) {
                  @if (yourAccountForm.get('romanisedLastName')?.errors?.['invalidCharacters']) {
                    <small data-testid="romanisedlastname-format-error" class="p-error">
                      {{ 'USER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                    </small>
                  }
                }
              </div>

              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 disabled">
                <label data-testid="my-account-field-username" class="block text-sm" for="username">{{ 'YOUR_ACCOUNT.USERNAME' | translate }}</label>
                <input data-testid="my-account-username-input" type="text" readonly formControlName="username" tabindex="13" autocomplete="off">
              </div>

              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 disabled">
                <label data-testid="my-account-field-role" class="block text-sm" for="role">{{ 'YOUR_ACCOUNT.ROLE' | translate }}</label>
                <input data-testid="my-account-role-input" type="text" readonly formControlName="role" tabindex="14" autocomplete="off">
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" [ngClass]="{'disabled': !allowUserUpdate}">
                <label data-testid="my-account-field-email" class="block text-sm" for="email">{{ 'YOUR_ACCOUNT.EMAIL' | translate }} <i class="icon-required-field"></i></label>
                <input data-testid="my-account-email-input" type="text" formControlName="email" tabindex="16" autocomplete="off">
                @if (
                  yourAccountForm.get('email')?.invalid &&
                  (yourAccountForm.get('email')?.dirty || yourAccountForm.get('email')?.touched)
                ) {
                  @if (yourAccountForm.get('email')?.hasError('required')) {
                    <small data-testid="my-account-email-mandatory" class="p-error">
                      {{ 'YOUR_ACCOUNT.VALIDATE_EMAIL' | translate }}
                    </small>
                  }
                  @if (yourAccountForm.get('email')?.errors?.['invalidEmail']) {
                    <small data-testid="my-account-email-format-error" class="p-error">
                      {{ 'YOUR_ACCOUNT.VALIDATE_EMAIL_SYNTAX' | translate }}
                    </small>
                  }
                }
              </div>
            </section>
            <section class="row">
              <div class="flex flex-col col-12 mb-4 mt-4">
                <h2 data-testid="my-account-security">{{ 'YOUR_ACCOUNT.SECURITY' | translate }}</h2>
              </div>
              <div class="field-wr flex flex-col col-12">
                @if (!isMfaMandatory) {
                  <p class="block text-sm">{{ 'YOUR_ACCOUNT.SECURITY_BLOCK_DESCRIPTION' | translate }}</p>
                }
                @if (isMfaMandatory && passwordUpdate) {
                  <p class="block text-sm">{{ 'YOUR_ACCOUNT.PASSWORD_DESCRIPTION' | translate }}</p>
                }
              </div>

              <div class="col-12">
                <div class="flex items-center gap-2">
                  @if (passwordUpdate && allowUserChangePassword) {
                    <button data-testid="my-account-passoword-update-btn" class="btn outline-btn" (click)="onOpenChangePasswordModalbox()">
                      {{ 'YOUR_ACCOUNT.BTN_OPEN_CHANGE_PASSWORD_MODALBOX' | translate }}
                    </button>
                  }

                  @if (!userHasMfaEnabled || isMfaMandatory) {
                    <button data-testid="my-account-mfa-btn" class="btn outline-btn" [disabled]="isMfaMandatory" (click)="onOpenMfaModalbox()">
                      {{ 'YOUR_ACCOUNT.BTN_CONFIGURE_MFA' | translate }}
                    </button>
                  }

                  @if (!isMfaMandatory && userHasMfaEnabled) {
                    <button data-testid="my-account-mfa-btn" class="btn outline-btn danger-btn" (click)="onConfirmUnenrollMfa()">
                      {{ 'YOUR_ACCOUNT.BTN_UNENROLL_MFA' | translate }}
                    </button>
                  }
                </div>

                @if (isMfaMandatory) {
                  <p class="py-4 text-sm mt-1 italic">{{ 'YOUR_ACCOUNT.MFA_IS_MANDATORY_INFO' | translate }}</p>
                }
              </div>
            </section>
            <div class="row">
              <div class="col-12 mt-6 mb-4 pt-8 border-t">
                <div class="flex items-center justify-end gap-3">
                  @if (allowUserUpdate) {
                    <button data-testid="my-account-update-btn" class="btn primary-btn" [disabled]="yourAccountForm.invalid" (click)="submitForm()">
                      {{ 'YOUR_ACCOUNT.SAVE_SETTINGS' | translate }}
                    </button>
                  }
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
}

<!-- Modalbox: update password -->
<p-dialog [header]="'MODALBOXES.TITLE_CHANGE_PASSWORD' | translate" [(visible)]="displayChangePasswordModalbox" modal="true" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false">
  <form class="mt-0" [formGroup]="updatePasswordForm">
    <div class="row">
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <label data-testid="password-label" class="block text-sm" for="new-pass">{{ 'YOUR_ACCOUNT.NEW_PASSWORD' | translate }} <i class="icon icon-info"
            pTooltip="{{ 'YOUR_ACCOUNT.PASSWORD_TOOLTIP' | translate }}" tooltipPosition="top"></i></label>
        <div class="password-field-wr">
          <input data-testid="password" [type]="showPassword ? 'text' : 'password'" formControlName="password" tabindex="18" autocomplete="off" class="password-field">
          <button data-testid="password-toggle" type="button" class="btn-icon-only btn-icon eye-toggle" [ngClass]="showPassword ? 'icon-eye-hide' : 'icon-eye-display'" (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"></button>
        </div>
        @if (
          updatePasswordForm.get('password')?.invalid &&
          (updatePasswordForm.get('password')?.dirty || updatePasswordForm.get('password')?.touched)
        ) {
          @if (updatePasswordForm.get('password')?.hasError('required')) {
            <small data-testid="password-validation-error" class="p-error">
              {{ 'YOUR_ACCOUNT.VALIDATE_PASSWORD' | translate }}
            </small>
          }

          @if (updatePasswordForm.get('password')?.errors?.['invalidPassword']) {
            <small data-testid="password-format-error" class="p-error">
              {{ 'YOUR_ACCOUNT.FORMAT_PASSWORD' | translate }}
            </small>
          }
        }
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <label data-testid="confirm-password-label" class="block text-sm" for="confirm-paswords">{{ 'YOUR_ACCOUNT.REPEAT_PASSWORD' | translate }}</label>
        <div class="password-field-wr">
          <input data-testid="confirm-password" [type]="showConfirmPassword ? 'text' : 'password'"
            formControlName="confirmPassword" tabindex="19" autocomplete="off" class="password-field">
          <button data-testid="confirm-password-toggle" type="button" class="btn-icon-only btn-icon eye-toggle" [ngClass]="showConfirmPassword ? 'icon-eye-hide' : 'icon-eye-display'" (click)="toggleConfirmPasswordVisibility()" [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'"></button>
        </div>
        @if (
          updatePasswordForm.get('confirmPassword')?.touched &&
          (updatePasswordForm.get('confirmPassword')?.invalid || updatePasswordForm.get('confirmPassword')?.dirty)
        ) {
          @if (updatePasswordForm.get('confirmPassword')?.errors?.['passwordMismatch']) {
            <small data-testid="confirm-password-match-error" class="p-error">
              {{ 'YOUR_ACCOUNT.VALIDATE_PASSWORD_MATCH' | translate }}
            </small>
          }

          @if (
            !updatePasswordForm.get('confirmPassword')?.errors?.['passwordMismatch'] &&
            updatePasswordForm.get('confirmPassword')?.hasError('required')
          ) {
            <small data-testid="confirm-password-validation-error" class="p-error">
              {{ 'YOUR_ACCOUNT.VALIDATE_CONFIRM_PASSWORD' | translate }}
            </small>
          }
        }
      </div>
    </div>
  </form>
  <ng-template #footer>
    <button data-testid="change-password-cancel-btn" type="button" class="btn outline-btn"
      (click)="onCancelChangePassword()">{{ 'MODALBOXES.BTN_CANCEL_CHANGE_PASSWORD' | translate }}</button>
    <button data-testid="change-password-update-btn" class="mt-auto btn primary-btn" pButton [disabled]="updatePasswordForm.invalid"
      (click)="onSubmitChangePasswordForm()">{{ 'MODALBOXES.BTN_CHANGE_PASSWORD' | translate }}</button>
  </ng-template>
</p-dialog>

<!-- Modalbox: MFA -->
<p-dialog [header]="'MODALBOXES.TITLE_MFA' | translate" [(visible)]="displayMfaModalbox"
  modal="true" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" class="compact-modal">
  <div class="row">
    <div class="col-12">
      @if (!verificationError) {
        <div class="notice text-sm px-4 py-4 mb-6">
          <p>{{ 'OTP.OTP_SETUP_HINT' | translate }}</p>
        </div>
      }
      @if (verificationError) {
        <div class="notice error text-sm mb-4">
          <p class="font-semibold">{{ 'OTP.ERROR_HINT_TITLE' | translate }}</p>
          <p>{{ 'OTP.ERROR_GENERIC_MESSAGE' | translate }}</p>
        </div>
      }
    </div>
  </div>
  <form class="mt-0" [formGroup]="mfaVerificationCodeForm">
    <div class="row">
      @if (qrData) {
        <div class="qr-wr mt-2 mb-4 text-center">
          <div class="flex flex-col align-items-center">
            <qrcode
              #qrCodeEl
              [qrdata]="qrData"
              [width]="128"
              [errorCorrectionLevel]="'M'">
            </qrcode>

            <span class="text-sm mt-3 font-semibold block">
              {{ 'OTP.OTP_KEY' | translate }}
            </span>

            <div class="otp-key-wrapper">
              <code class="otp-key">{{ mfaConfigKey }}</code>
              <button
                data-testid="copy-btn"
                type="button"
                class="copy-btn"
                (click)="copyMfaKey()">
                {{ 'OTP.BTN_COPY' | translate }}
              </button>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="row flex justify-center">
      <div class="col-12">
        <div class="field-wr">
          <label data-testid="verification-code-label"  for="verification-code" class="block text-sm">{{ 'OTP.VERIFICATION_CODE' | translate }}</label>
          <div class="mt-2">
            <input data-testid="verification-code"   type="text" name="verification-code"
              placeholder="{{ 'OTP.VERIFICATION_CODE_PLACEHOLDER' | translate }}" maxlength="6"
              formControlName="verificationCode" required autocomplete="off" class="text-field">
          </div>
        </div>
      </div>
    </div>
  </form>
  <ng-template #footer>
    <div class="row flex justify-center">
      <div class="col-12 px-3">
        <button data-testid="verify-code-btn"  class="w-full mx-auto mt-auto btn primary-btn"
          [disabled]="mfaVerificationCodeForm.invalid" (click)="verify()">
          {{ 'MODALBOXES.BTN_MFA_VERIFY' | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- MFA: unenroll device -->
<p-dialog [(visible)]="displayMfaUnenrollModalbox" [header]="'MODALBOXES.TITLE_UNENROLL_MFA' | translate" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false">
  <div>
    <p>{{ 'MODALBOXES.BODY_UNENROLL_MFA_CONFIRM' | translate }}</p>
    <div class="notice warning text-sm mt-4 mb-8">
      <p>{{ 'MODALBOXES.BODY_UNENROLL_MFA_WARNING' | translate }}</p>
    </div>
  </div>
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <button data-testid="unernroll-cancel-btn" class="btn outline-btn" (click)="displayMfaUnenrollModalbox = false">
        {{ 'MODALBOXES.BTN_CANCEL' | translate }}
      </button>
      <button data-testid="unernroll-confirm-btn" class="btn primary-btn p-button p-component" (click)="onUnenrollMfa()">
        {{ 'MODALBOXES.BTN_CONFIRM' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>
